import all from './all';
import items from './items';
import store from './store';
import show from './show';
import update from './update';

export default {
  all,
  items,
  store,
  show,
  update,
};



// WEBPACK FOOTER //
// ./src/app/services/equipment/index.js